// FWFS: Cart yardage qty controls (units <-> yards)
// 1 unit = 0.25 yd, min 0.5 yd (2 units)

(function () {
  const UNITS_PER_YARD = 4;
  const MIN_UNITS = 2; // 0.5 yd

  function isYardageQuantity(root) {
    return root && root.classList && root.classList.contains("quantity--yardage");
  }

  function formatYards(y) {
    // keep nice formatting: 0.5, 1.25, 2, 2.5 etc
    const v = Math.round(y * 100) / 100;
    return String(v).replace(/\.0$/, "");
  }

  function unitsToYards(units) {
    return units / UNITS_PER_YARD;
  }

  function getUnitInput(root) {
    // Shopify cart usually has a real input that drives updates.
    // We prefer an input that is NOT the visible yards input.
    const inputs = root.querySelectorAll("input.quantity__input");
    if (!inputs || !inputs.length) return null;

    // If you have a visible yards input class, exclude it
    for (const inp of inputs) {
      if (inp.classList.contains("quantity__input--yards")) continue;
      return inp;
    }

    // fallback: look for hidden units input if you used that pattern
    return root.querySelector('input[type="hidden"][name="quantity"], input[type="hidden"][name^="updates"], input[name^="updates"]');
  }

  function getYardsInput(root) {
    return root.querySelector("input.quantity__input--yards");
  }

  function setDisplayFromUnits(root, units) {
    const yardsInput = getYardsInput(root);
    if (yardsInput) yardsInput.value = formatYards(unitsToYards(units));
  }

  function bumpUnits(root, delta) {
    const unitInput = getUnitInput(root);
    if (!unitInput) return;

    let units = parseInt(unitInput.value, 10);
    if (!Number.isFinite(units)) units = MIN_UNITS;

    units = units + delta;
    if (units < MIN_UNITS) units = MIN_UNITS;

    // IMPORTANT: Shopify must receive integer units
    unitInput.value = String(units);

    // Update visible yards text
    setDisplayFromUnits(root, units);

    // Trigger whatever the theme uses to update cart (usually listens to change)
    unitInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function initOneQuantity(root) {
    if (!isYardageQuantity(root)) return;

    const unitInput = getUnitInput(root);
    if (!unitInput) return;

    // Sync display on load
    let units = parseInt(unitInput.value, 10);
    if (!Number.isFinite(units)) units = MIN_UNITS;
    if (units < MIN_UNITS) units = MIN_UNITS;
    setDisplayFromUnits(root, units);

    const minusBtn = root.querySelector('.quantity__button[name="minus"]');
    const plusBtn  = root.querySelector('.quantity__button[name="plus"]');

    if (minusBtn) {
      minusBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        bumpUnits(root, -1);
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        bumpUnits(root, +1);
      });
    }

    // If someone types in yards input, convert back to units (optional)
    const yardsInput = getYardsInput(root);
    if (yardsInput) {
      yardsInput.addEventListener("change", function () {
        let y = parseFloat(yardsInput.value);
        if (!Number.isFinite(y)) y = 0.5;
        if (y < 0.5) y = 0.5;

        // snap to 0.25
        y = Math.round(y / 0.25) * 0.25;

        let units = Math.round(y * UNITS_PER_YARD);
        if (units < MIN_UNITS) units = MIN_UNITS;

        unitInput.value = String(units);
        yardsInput.value = formatYards(unitsToYards(units));
        unitInput.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }
  }

  function initAll() {
    document.querySelectorAll(".quantity.quantity--yardage").forEach(initOneQuantity);
  }

  // Initial
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // If your cart re-renders via AJAX, re-init after updates
  document.addEventListener("cart:refresh", initAll);
  document.addEventListener("cart:updated", initAll);
})();
